// // src/utils/crypto-utils.js

// // Utility functions for AES-256 encryption and decryption using Web Crypto API (client-side)

// const textEncoder = new TextEncoder();
// const textDecoder = new TextDecoder();

// // Hardcoded key (32 bytes for AES-256) in hexadecimal format
// const HARD_CODED_KEY_HEX = 'bcc7eec5958f25e41a9dbd198039431bcd83fece1825026efba938b6ad742a73';

// // Function to import the hardcoded key
// const importHardcodedKey = async () => {
//   const keyData = Uint8Array.from(HARD_CODED_KEY_HEX.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
//   return window.crypto.subtle.importKey(
//     "raw",
//     keyData,
//     { name: "AES-CBC" },
//     false,
//     ["encrypt", "decrypt"]
//   );
// };

// // Function to encrypt the payload (React)
// export const encryptPayload = async (payload) => {
//   const key = await importHardcodedKey();
//   const iv = window.crypto.getRandomValues(new Uint8Array(16)); // 16-byte IV for AES-CBC
//   const encoded = textEncoder.encode(JSON.stringify(payload));

//   const encrypted = await window.crypto.subtle.encrypt(
//     { name: "AES-CBC", iv },
//     key,
//     encoded
//   );

//   // Convert IV and encrypted data to base64 strings for transmission
//   const ivHex = Array.from(iv).map(b => b.toString(16).padStart(2, '0')).join('');
//   const encryptedData = btoa(String.fromCharCode(...new Uint8Array(encrypted)));

//   return `${ivHex}:${encryptedData}`; // Return IV and encrypted data in hex and base64 format, separated by colon
// };

// // Function to decrypt the payload (React)
// export const decryptPayload = async (encryptedPayload) => {
//   try {
//     const key = await importHardcodedKey();

//     // Split IV and encrypted data
//     const [ivHex, encryptedData] = encryptedPayload.split(':');
//     const iv = Uint8Array.from(ivHex.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));

//     const decrypted = await window.crypto.subtle.decrypt(
//       { name: "AES-CBC", iv },
//       key,
//       Uint8Array.from(atob(encryptedData), c => c.charCodeAt(0))
//     );

//     return JSON.parse(textDecoder.decode(decrypted));
//   } catch (error) {
//     console.error('Error during decryption:', error.message);
//     throw new Error('Invalid encrypted payload');
//   }
// };



import CryptoJS from 'crypto-js';

// Hardcoded key
const HARD_CODED_KEY = CryptoJS.enc.Hex.parse(`${process.env.REACT_APP_CUSTOM_HASH}`);

// Function to encrypt the payload
export const encryptPayload = (payload) => {
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), HARD_CODED_KEY, {
    iv: iv,
  });

  // Convert IV and encrypted data to base64 strings for transmission
  const ivHex = iv.toString(CryptoJS.enc.Hex);
  const encryptedData = encrypted.toString();

  return `${ivHex}:${encryptedData}`; // Return IV and encrypted data
};

// // Function to decrypt the payload
// export const decryptPayload = (encryptedPayload) => {
//   const [ivHex, encryptedData] = encryptedPayload.split(':');
//   const iv = CryptoJS.enc.Hex.parse(ivHex);

//   const decrypted = CryptoJS.AES.decrypt(encryptedData, HARD_CODED_KEY, {
//     iv: iv,
//   });
// console.log('decrypted', decrypted);
//   return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
// };

export const decryptPayload = (encryptedPayload) => {
  if (!encryptedPayload || typeof encryptedPayload !== 'string' || !encryptedPayload.includes(':')) {
    throw new Error('Invalid encrypted payload format');
  }

  const [ivHex, encryptedData] = encryptedPayload.split(':');

  if (!ivHex || !encryptedData) {
    throw new Error('IV or Encrypted Data missing');
  }

  const iv = CryptoJS.enc.Hex.parse(ivHex);

  const decrypted = CryptoJS.AES.decrypt(encryptedData, HARD_CODED_KEY, { iv: iv });

  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

  if (!decryptedText) {
    throw new Error('Decryption failed: Empty result');
  }

  return JSON.parse(decryptedText);
};
